module.exports = "/static/fonts/OpenSans-Semibold.woff2";